import React from 'react';

import useGetPeriodJobassignmentDetails from 'state/remote/remote-organization/use-get-period-job-assignment-details';

import Typography from 'components-new/typography/typography';

import LoadingPage from 'pages/LoadingPage';

import EmptyState from 'components-new/empty-state/empty-state';

import { createLocale } from 'locales';

import ProgressBar from './ProgressBar';
import InvitedFreelancersTable from './InvitedFreelancersTable';
import AssignmentsTable from './AssignmentsTable';

const localize = createLocale('organisationPeriodJobsLocales');
interface assignmentDetailsTypes {
  jobId: string | undefined;
}

const AssignmentDetailsView: React.FC<assignmentDetailsTypes> = (props) => {
  const { jobId } = props;
  const {
    data: assignmentDetails,
    isLoading,
    error,
  } = useGetPeriodJobassignmentDetails(parseInt(jobId || '0', 10));

  if ((!jobId || !assignmentDetails?.invited_freelancers) && isLoading)
    return <LoadingPage />;

  if (!isLoading && error) return <EmptyState errorText={error} />;

  return (
    <div className="w-full md:mx-3">
      <Typography as="h2" variant="heading-2" className="text-gray-800 mb-4">
        {localize('invitedFreelancers')}
      </Typography>

      <InvitedFreelancersTable assignmentDetails={assignmentDetails} />

      <Typography
        as="h2"
        variant="heading-2"
        className="text-gray-800 mt-8 mb-4"
      >
        {localize('assignmentDetails')}
      </Typography>
      <ProgressBar assignmentDetails={assignmentDetails} className="my-4" />
      <AssignmentsTable
        assignmentDetails={assignmentDetails}
        className="mb-20"
      />
    </div>
  );
};

export default AssignmentDetailsView;
